import { createRouter, createWebHashHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import DownloadPage from '../views/DownloadPage.vue';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/download',
    name: 'DownloadPage',
    component: DownloadPage,
  },
];

const router = createRouter({
  // 使用 createWebHashHistory() 替代 createWebHistory()
  history: createWebHashHistory(), 
  routes,
});

export default router;